/** @jsx jsx */
import { jsx } from  '@emotion/core'
import NumberFormat from 'react-number-format';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import t from '../i18n'
import { Table, Select, Row, Col, Switch, Button, Space } from 'antd';

import removeTrailingZeros from 'remove-trailing-zeros'

import React, { Component } from 'react';
import { ReloadOutlined, FileExcelOutlined } from '@ant-design/icons'
import StockLocations from './stock_locations'
import { VariantList } from './VariantList';
import StockHistory from './stock_history'


export default class StockReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      stockLocations: [],
      selectedStockLocations: null,
      filteredInfo: null,
      columns: this.getColumns(),
      showInStock: true,
      variantData: {},
      showHistory: false,
      reportType: 'transfers'
    }

    const that = this;
    this.dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const columns = that.state.columns;
        const item = columns.splice(fromIndex, 1)[0];
        columns.splice(toIndex, 0, item);
        that.setState({
          columns
        });
      },
      nodeSelector: "th"
    };

    
  }

  componentDidMount = () => {
    this.loadData();
  }

  loadData = (callback) => {
    const $this = this
    $this.setState({
      loading: true
    });

    $.ajax({
      type: "get",
      dataType: 'json',
      url: '/stock_transfers/' + `/${document.URL.split("/").pop()}`,
      data: {
        token: Spree.api_key
      },
      success: function (response) {
        $this.setState({
          loading: false,
          data: response.line_items,
          stockLocations: response.stock_locations,
        });

      },
      error: function (response, textStatus, errorThrown) {
        show_flash('error', response.responseText);
      },

    });
  }

  stockLocationChangedHandler = (locations) => {
    this.setState({ selectedStockLocations: locations })
    this.setState({columns: this.getColumns(locations)})
  }

  variantChangedHandler = (variants) => {
    let { filteredInfo, columns } = this.state
    filteredInfo = filteredInfo || {}

    const ids = variants?.map( v => v.id)
    filteredInfo.item = ids;
    this.setState({ filteredInfo }, function () { this.setState({ columns }) })


  }

  variantList = () => {
    return this.state.data.map((d) => ({ name: d.variant_name, id: d.variant_id}) )
  }



loadHistory = (variantData) => {
  this.setState({ showHistory: true, variantData, locationData: this.state.stockLocations[0] }) 

}

  
getColumns = (locations) => {

  // let { filteredInfo } = this.state;
   
  let cols = 
  [
    {
      title: <div className="text-right"> # </div> ,
      width: 50,
      render: (text, record, index) => index + 1
    },
    {
      title: t('item'),
      align: "left",
      key: 'variant_name',
      filters: [
        {
          text: 'POS Item',
          value: 'is_pos_item',
        },
        {
          text: 'Inventory Item',
          value: 'is_inventory_item',
        },
      ],

      render: (text, record) => <a className="pull-left" href="#" onClick={() => this.loadHistory(record)}> <span style={{fontSize: '0.7em'}}>{record.variant_name} </span> <span><br/>{record.variant_name_ar} </span> </a>
      },
    {
      title: <div className="text-right"> {t('qty')} </div>,
      dataIndex: 'qty'
    },
   
  ]
  
  return cols;
  
  }

 
 


  render() {
    // alert(_global_currency_code)
    const { data, locationData, variantData, columns, showHistory } = this.state
    const params = new URLSearchParams(window.location.search);
    const variant_id = +params.get("variant_id");

    return (
      <div>

        <StockHistory 
          historyItems = {[1,2,3,4]}
          showHistory={showHistory}
          onClose={ () => this.setState({ showHistory: false })}
          variantData={ variantData }
          locationData = { locationData }
        />          
                      
          <Table 
            columns={ columns} 
            dataSource={data} 
            pagination={false}
            size = {"small"}
            bordered
            loading = {this.state.loading}
            rowKey="id"
          rowClassName={(record, index) => { return variant_id && record.variant_id == variant_id ? "ant-table-row-selected" : ''  }}
          />


      </div>
    )
  }
}









